import React from "react";
import { Card, Collapse, Form } from "react-bootstrap";
import clickSimCard from "../../../assets/img/sim.png";

const AssignSimProduct = ({
  product,
  values,
  handleChange,
  setFieldValue,
  touched,
  errors,
  setFieldTouched,
}) => {
  const simProducts = values.simProducts || [];
  const isSelected =
    values.simProducts?.some((p) => p.id === product.id) ?? false;

  const productIndex = simProducts.findIndex((p) => p.id === product.id);
  console.log(productIndex);

  const handleToggle = (e) => {
    const checked = e.target.checked;

    console.log(product);

    if (checked) {
      if (!isSelected) {
        setFieldValue("simProducts", [
          ...simProducts,
          {
            id: product.id,
          },
        ]);
      }
    } else {
      setFieldValue(
        "simProducts",
        simProducts.filter((p) => p.id !== product.id)
      );
    }
  };

  const handleFieldChange = (field) => (e) => {
    setFieldValue(`simProducts.${productIndex}.${field}`, e.target.value);
  };

  const handleFieldBlur = (field) => (e) => {
    setFieldTouched(`simProducts.${productIndex}.${field}`, true);
  };

  return (
    <Card
      style={{
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
      }}
    >
      <Card.Img
        src={clickSimCard}
        style={{
          height: "auto",
          objectFit: "cover",
          borderBottomLeftRadius: "0",
          borderBottomRightRadius: "0",
          borderTopRightRadius: "20px",
          borderTopLeftRadius: "20px",
        }}
      />
      <Card.Body
        style={{
          backgroundColor: "#042742",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
        }}
      >
        <div className="d-flex justify-content-between align-items-start">
          <Card.Title className="mb-0" style={{ color: "#fff" }}>
            {product.description}
          </Card.Title>

          <Form.Check
            type="checkbox"
            id={`simProduct-${product.id}`}
            checked={isSelected}
            onChange={handleToggle}
            // simple visual tweak – enlarge hit area a bit
            style={{ transform: "scale(1.2)", marginLeft: "0.5rem" }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default AssignSimProduct;
